import styled from 'styled-components';
import { devices } from 'config/devices';

export const MenuList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 10px;
  // background-color: #f0f0f0;

  @media ${devices.xs} {
    display: block;
    // flex-wrap: wrap;
    justify-content: center;
    flex: 0 0 calc(50% - 10px);
    margin: 5px;  
    padding-top: 0;
  } 
`;
